import { axiosInstance } from './apiCommon';

export interface CustomValidationRuleModel {
  ruleName: string;
  severity: string | null;
  isEnabled: boolean;
  activeFrom: string | null;
  activeTo: string | null;
}

export function isValidationRuleActive(rule: CustomValidationRuleModel, dateTime: Date): boolean {
  if (!rule.isEnabled) {
    return false;
  }
  if (rule.activeFrom && dateTime < new Date(rule.activeFrom)) {
    return false;
  }
  if (rule.activeTo && dateTime > new Date(rule.activeTo)) {
    return false;
  }
  return true;
}

export const getValidationRules = async () => {
  return (await axiosInstance.get<CustomValidationRuleModel[]>(`/api/admin/v1/AdminValidationRules`)).data;
};

export const upsertValidationRule = async (data: CustomValidationRuleModel) => {
  return await axiosInstance.put(`/api/admin/v1/AdminValidationRules`, data);
};

export const deleteValidationRule = async (ruleName: string) => {
  return await axiosInstance.delete(`/api/admin/v1/AdminValidationRules/${encodeURIComponent(ruleName)}`);
};
